const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        subtitle: "Crie sua conta para começar a usar nossa plataforma",
        welcomeTitle: "Bem-vindo ao {{appName}}",
        welcomeMessage:
          "Crie sua conta e comece a gerenciar seus atendimentos de forma eficiente.",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          submitting: "Cadastrando...",
          login: "Já tem uma conta? Entre!",
        },
        validation: {
          nameRequired: "O nome deve ter pelo menos 2 caracteres",
          companyRequired: "O nome da empresa deve ter pelo menos 2 caracteres",
          emailInvalid: "Digite um email válido",
          passwordTooShort: "A senha deve ter pelo menos 5 caracteres",
          phoneRequired: "O telefone é obrigatório",
          planRequired: "Selecione um plano",
        },
      },
      login: {
        title: "Login",
        welcomeTitle: "Bem-vindo ao {{appName}}",
        welcomeMessage:
          "Um novo dia chegou. É o seu dia para moldar. Faça login e comece a trabalhar em seus projetos.",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acesse sua conta para continuar",
        },
        buttons: {
          submit: "Entrar",
          noAccount: "Não tem uma conta?",
          register: "Cadastre-se!",
          showPassword: "Mostrar senha",
          hidePassword: "Ocultar senha",
        },
        footer: {
          rights: "Todos os direitos reservados",
        },
      },
      companies: {
        title: "Empresas",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        loadingMessage: "Os dados do Dashboard serão carregados em breve...",
        refreshing: "Atualizando dados...",
        pleaseWait: "Por favor, aguarde",
        refresh: "Atualizar dados",
        general: {
          title: "Informações Gerais",
        },
        overview: {
          title: "Visão Geral e Avaliações",
        },
        activity: {
          title: "Atividade por Período e Desempenho",
          daily: "Atividade Diária",
          perHour: "Atividade por Hora",
        },
        distribution: {
          title: "Distribuição por Canal e Setor",
          byChannel: "Distribuição por Canal",
          byQueue: "Distribuição por Setor",
          channels: "canais",
          queues: "setores",
        },
        hourly: {
          title: "Atividade por Hora",
          peak: "Pico",
          between: "Entre",
          and: "e",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
          weeklyOverview: "Visão Semanal",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
          messages: "Mensagens",
        },
        total: "Total",
        noData: "Sem dados disponíveis",
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "Atendimento",
          averageWaitingTime: "Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
          totalTickets: "Total de Tickets",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuário",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        filters: {
          title: "Filtros",
          apply: "Filtrar",
          reset: "Limpar Filtros",
          quickFilters: "Filtros Rápidos",
          customRange: "Período Personalizado",
          allTime: "Todo o Período",
          today: "Hoje",
          yesterday: "Ontem",
          last7days: "Últimos 7 dias",
          thisWeek: "Esta semana",
          thisMonth: "Este mês",
          lastMonth: "Mês passado",
          sections: "Visibilidade das Seções",
          refreshInterval: "Intervalo de atualização:",
          refreshManual: "Manual",
          refresh5min: "5 minutos",
          refresh15min: "15 minutos",
          refresh30min: "30 minutos",
          until: "até",
          hideSection: "Ocultar seção",
          showAll: "Mostrar Todas",
          hideAll: "Ocultar Todas",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
          ratingTooltip: "dos tickets avaliados",
        },
        tickets: {
          overview: "Status dos Tickets",
          timeline: "Timeline de Atendimentos",
          created: "Tickets Criados",
          active: "Tickets ativos atualmente",
          pending: "Tickets aguardando atendimento",
          completed: "Atendimentos concluídos",
          demandActive: "Demanda ativa",
          demandPassive: "Demanda passiva",
          inAttendanceTooltip: "Tickets que estão sendo atendidos no momento",
          waitingTooltip:
            "Tickets que ainda não foram atribuídos a um atendente",
          finalizedTooltip: "Tickets que foram fechados e resolvidos",
          activeTicketsTooltip: "Tickets que foram iniciados pela empresa",
          passiveTicketsTooltip: "Tickets que foram iniciados pelo cliente",
        },
        messages: {
          title: "Mensagens por Período",
          received: "Recebidas",
          sent: "Enviadas",
          total: "Total",
          ratio: "Proporção",
        },
        attendants: {
          performance: "Ranking de Atendentes",
          online: "Online agora",
        },
        topContacts: {
          title: "Ranking de Contatos",
          columns: {
            contact: "Contato",
            tickets: "Tickets",
            queue: "Setor",
            time: "Tempo",
          },
          noData: "Sem contatos para exibir",
          tooltip: "Top 10 contatos com mais tickets abertos no período",
        },
        actions: {
          filter: "Filtrar",
          refresh: "Atualizar",
          fullscreen: "Tela cheia",
          exitFullscreen: "Sair da tela cheia",
        },
        online: "Online agora",
        serviceTime: "Tempo médio de atendimento",
        waitingTime: "Tempo médio de espera na fila",
        newContacts: "Novos contatos no período",
        fromLastMonth: "desde o mês passado",
        newContactsTooltip: "Novos contatos registrados no período selecionado",
        activeAttendantsTooltip: "Número de atendentes disponíveis online",
        timeMetrics: "Métricas de Tempo",
        firstResponseTooltip:
          "Tempo médio até a primeira resposta do atendente",
        resolutionRateTooltip:
          "Percentual de tickets resolvidos em relação ao total",
        reopenedTicketsTooltip: "Tickets que foram reabertos após fechamento",
        avgTicketsPerDayTooltip: "Média diária de tickets no período",
        firstResponseTime: "Primeira Resposta",
        sort: {
          ascending: "Crescente",
          descending: "Decrescente",
          orderBy: "Ordenar por",
          tickets: "Número de Tickets",
          rating: "Avaliação",
          waitTime: "Tempo de Espera",
          serviceTime: "Tempo de Atendimento",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },

      contactImportWpModal: {
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde, reiniciando conexões...",
        callSupport: "Suporte",
        newConnection: "Nova conexão",
        restartConnections: "Reiniciar conexões",
        online: "Conectado",
        offline: "Desconectado",
        warning: "Pendente",
        check: "Verificar",
        facebook: {
          success:
            "Facebook conectado com sucesso! Agora configure suas páginas.",
        },
        telegram: {
          success: "Telegram conectado com sucesso!",
          title: "Telegram Bot",
          description: "Conecte seu Bot do Telegram para receber mensagens.",
          botToken: "Token do Bot",
        },
        cloudApi: {
          title: "WhatsApp API Oficial",
          description:
            "Conecte usando a API oficial do WhatsApp Business. Sem QR Code, sem Baileys.",
          connectionName: "Nome da conexão",
          phoneNumber: "Número do WhatsApp",
          success: "WhatsApp API Oficial conectado com sucesso!",
          tokenExpiredAlert:
            "Token da API Oficial inválido ou expirado. Atualize o token da conexão.",
          connect: "Conectar com Meta (Embedded Signup)",
          manualMode: "Ou configure manualmente →",
          save: "Salvar",
          cancel: "Cancelar",
        },
        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported: "Tickets importados foram fechados com sucesso!",
          importStopped: "Processo de importação interrompido com sucesso!",
          importStarted:
            "Processo de importação iniciado! Aguarde a preparação das mensagens.",
          qrCodeScanned:
            "QR Code lido com sucesso! Iniciando preparação para importação...",
          transferSuccess:
            "Transferência concluída. Tickets migrados: {{tickets}}. Agendamentos migrados: {{schedules}}.",
        },
        transferModal: {
          button: "Transferir tickets",
          title: "Transferir tickets e agendamentos",
          message:
            "Escolha a conexão de origem e a conexão de destino. A migração atualiza os IDs da conexão nos tickets e agendamentos.",
          sourceLabel: "Conexão de origem",
          targetLabel: "Conexão de destino",
          helper:
            "Você pode transferir para qualquer outra conexão da mesma empresa.",
          confirm: "Transferir",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Tem certeza? Esta ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
          closedImportedTitle: "Fechar Tickets Importados",
          closedImportedMessage:
            "Tem certeza? Todos os tickets importados serão fechados.",
          transferLabel: "Selecione a nova conexão para os tickets",
          transferHelper:
            "Os tickets serão mantidos nas mesmas filas após a transferência.",
          transferUnavailable:
            "Nenhuma outra conexão desse canal está disponível. Crie uma nova conexão antes de excluir.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          editConnection: "Editar conexão",
          disconnect: "Desconectar",
          restart: "Reiniciar",
          resume: "Retomar",
          pause: "Pausar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
          preparing: "Preparando mensagens",
          importing: "Importando mensagens",
          closedImported: "Fechar importados",
          stopImport: "Parar importação",
        },
        toolTips: {
          disconnected: {
            title: "Falha na conexão com o WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Aguardando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a conexão",
          },
          connected: {
            title: "Conexão estabelecida",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique em 'Desconectar' para obter um novo QR Code",
          },
          importing: {
            title: "Importação em andamento",
            content:
              "Suas mensagens estão sendo importadas. Este processo pode levar algum tempo dependendo da quantidade de mensagens.",
          },
          preparing: {
            title: "Preparando importação",
            content:
              "Estamos analisando suas mensagens do período selecionado. Aguarde enquanto preparamos tudo para a importação.",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Atualizado em",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
        status: {
          connected: "Conectado",
          disconnected: "Desconectar",
          opening: "Abrindo",
          qrcode: "QR Code",
          timeout: "Tempo esgotado",
          pairing: "Pareando",
          preparing: "Preparando",
          importing: "Importando",
        },
        badges: {
          default: "Padrão",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data",
          preparingMessages:
            "Aguarde enquanto preparamos suas mensagens para importação...",
          analyzingMessages: "Analisando mensagens do período selecionado...",
          importStarted: "Importação iniciada! Não feche esta janela.",
          importInProgress:
            "Importação em andamento. Isso pode levar alguns minutos.",
          qrCodeSuccess:
            "QR Code lido com sucesso! Iniciando preparação para importação...",
        },
        importStatus: {
          preparing: "Preparando importação",
          analyzing: "Analisando mensagens",
          importing: "Importando mensagens",
          finishing: "Finalizando importação",
          completed: "Importação concluída",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        tabs: {
          general: "Geral",
          integrations: "Integrações",
          messages: "Mensagens",
          chatbot: "Chatbot",
          assessments: "Avaliações",
          schedules: "Horários",
        },
        form: {
          name: "Nome",
          provider: "Provedor",
          default: "Padrão",
          group: "Permitir Grupos",
          groupAsTicket: "Grupos como Tickets",
          importOldMessagesEnable: "Importar mensagens antigas",
          importOldMessagesGroups: "Importar mensagens de grupos",
          closedTicketsPostImported: "Fechar tickets após importação",
          importOldMessages: "Data inicial para importação",
          importRecentMessages: "Data final para importação",
          queueIdImportMessages: "Fila para mensagens importadas",
          token: "Token",
          botToken: "Token do Bot (Telegram)",
          sendIdQueue: "Fila para redirecionamento",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem fora do horário",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          collectiveVacationStart: "Início das férias coletivas",
          collectiveVacationEnd: "Fim das férias coletivas",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          expiresTicket: "Encerrar chats abertos após x minutos",
          whenExpiresTicket: "Encerrar quando última mensagem for",
          closeLastMessageOptions1: "Após última mensagem do cliente",
          closeLastMessageOptions2: "Após última mensagem do atendente",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          inactiveMessage: "Mensagem de inatividade",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao deve ser enviada",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          prompt: "Prompt para IA",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Redirecionar para uma fila após um tempo sem resposta",
          importAlert:
            "ATENÇÃO: Ao habilitar a importação de mensagens, será necessário ler o QR Code novamente. Após a conexão ser estabelecida, o processo de preparação e importação será iniciado automaticamente.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem/Vídeo",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
        },
        success: "WhatsApp salvo com sucesso.",
        importWarning:
          "ATENÇÃO: Ao habilitar a importação de mensagens, será necessário ler o QR Code novamente. Após a conexão ser estabelecida, o processo de preparação e importação será iniciado automaticamente.",
        errorRatingMessage:
          "Mensagem de avaliação é obrigatória quando as avaliações estão habilitadas.",
        errorExpiresNPS:
          "Tempo para expirar ticket NPS é obrigatório quando as avaliações estão habilitadas.",
        errorSendQueue:
          "Selecione uma fila para redirecionamento quando o tempo for maior que zero.",
        errorGreetingMessage:
          "Mensagem de saudação é obrigatória quando duas ou mais filas são selecionadas.",
        queueRequired:
          "É necessário selecionar uma fila para importação de mensagens.",
        vacationDatesRequired:
          "As datas de início e fim das férias coletivas são obrigatórias quando a mensagem de férias está preenchida.",
        invalidDates:
          "A data de início não pode ser posterior à data de fim das férias coletivas.",
        errorExpiresInactiveMessage:
          "Mensagem de encerramento por inatividade é obrigatória quando o tempo de expiração de ticket está configurado.",
        errorTimeInactiveMessage:
          "Tempo para envio do aviso de inatividade é obrigatório quando a mensagem de inatividade está preenchida.",
        npsDisabled:
          "NPS está desabilitado nas configurações da empresa. Configure em: Configurações > Empresa",
        queueSelected:
          "Filas selecionadas. O Prompt e as Integrações estão desabilitados.",
        promptSelected:
          "Prompt selecionado. As Filas e Integrações estão desabilitadas.",
        integrationSelected:
          "Integração selecionada. As Filas e o Prompt estão desabilitados.",
        importInfo:
          "A conexão será reiniciada para importar as mensagens. Aguarde o processo de reconexão e importação.",
        status: {
          connected: "Conectado",
          opening: "Abrindo",
          qrcode: "QR Code",
          disconnected: "Desconectado",
          timeout: "Timeout",
          pairing: "Pareando",
          destroyed: "Destruído",
        },
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          deletedAll: "Todos os contatos foram excluídos com sucesso!",
          deleteAllQueued: "Exclusão em massa enfileirada. Aguarde o início...",
          deleteAllStarted: "Exclusão em massa iniciada.",
          deleteAllInProgress: "Excluindo contatos...",
          deleteAllCompleted: "Exclusão em massa concluída.",
          deleteAllError: "Erro ao executar exclusão em massa.",
          invalidConfirmation:
            "Confirmação inválida. Digite DELETAR em maiúsculas.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
          deleteAllTitle: "Excluir TODOS os contatos?",
          deleteAllMessage:
            "Esta ação irá excluir TODOS os contatos e não poderá ser desfeita.",
          deleteAllWarning: "Digite DELETAR em maiúsculas para confirmar:",
          deleteAllFinalTitle: "ATENÇÃO: Última verificação",
          deleteAllFinalMessage:
            "Você tem certeza absoluta que deseja excluir TODOS os contatos do sistema? Esta ação não poderá ser desfeita.",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
          deleteAll: "Excluir Todos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          number: "Número",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      forwardMessageBar: {
        messagesSelected: "selecionadas",
        selectMessages: "Selecione mensagens",
        forward: "Encaminhar",
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
          basicInfo: "Informações Básicas",
          voiceSettings: "Configurações de Voz",
          aiSettings: "Configurações de IA",
          queueLabel: "Selecione a fila",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot, gatilho e automação",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
        },
        errors: {
          numberWithDDI:
            "Informe o número com DDI. Para Brasil use 55 (ex.: 5511999999999) ou substitua pelo código do país (ex.: +12125551234)",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Encerrar Atendimento",
          expiresTicket: "Encerrar chats abertos após x minutos",
          whenExpiresTicket: "Encerrar quando última mensagem for",
          whenExpiresTicketAny: "Qualquer mensagem",
          whenExpiresTicketAgent: "Somente mensagem do atendente",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          timeInactiveMessage:
            "Enviar mensagem de inatividade após x minutos",
          inactiveMessage: "Mensagem de inatividade",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Início - Turno A",
          endTimeA: "Final - Turno A",
          startTimeB: "início - Turno B",
          endTimeB: "Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSettings: "Configurações do Typebot",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
          editImage: "Editar imagem",
          addImage: "Adicionar imagem",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          spyTicket: "Espiar ticket",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
          allowSendAudio: "Permitir envio de áudio",
          allowSendMedia: "Permitir envio de mídia",
          allowViewAllClosedTickets: "Ver tickets fechados de todos (nas minhas filas)",
          allowContacts: "Permitir Contatos",
          allowAutomations: "Permitir Automações",
          allowCampaigns: "Permitir Campanhas",
          allowAgendaCare: "Permitir AgendaCare",
          allowOdontoCare: "Permitir OdontoCare",
          allowPetCare: "Permitir PetCare 360",
          allowCallcenterUser: "Permitir Callcenter Usuário",
          allowCallcenterAdmin: "Permitir Callcenter Administrador",
          allowCashierPdv: "Permitir Caixa PDV",
          allowPdv: "Permitir PDV",
          allowErpPhone: "Permitir ERP-Phone",
          allowViewAllSchedules: "Ver agendamento de todos",
          lastName: "Sobrenome",
          cpf: "CPF",
          rg: "RG",
          ctps: "Carteira de Trabalho",
          birthday: "Aniversário",
          education: "Escolaridade",
          emergencyContacts: "Contatos de Emergência",
          emergencyName: "Nome do Contato",
          emergencyPhone: "Telefone do Contato",
          emergencyRelation: "Vínculo (Mãe, Esposa, etc.)",
        },
        settings: {
          personal: "Configurações Pessoais",
          general: "Configurações Gerais",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
          information: "Informações",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
        avatarModal: {
          title: "Editar foto de perfil",
          current: "Imagem atual",
          preview: "Nova imagem",
          dropHere: "Solte a imagem aqui",
          dropzoneText:
            "Arraste e solte uma imagem aqui, ou clique para selecionar",
          hint: "Para melhores resultados, utilize uma imagem quadrada",
          remove: "Remover foto",
          cancel: "Cancelar",
          save: "Salvar",
          changePhoto: "Alterar foto",
          uploadPhoto: "Enviar foto",
          imageDeleted: "Imagem removida!",
        },
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          error: "Erro de Envio",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
          whatsapp: "Conexão",
          openTicket: "Abrir Ticket",
          enabledOpenTicket: "Habilitado",
          disabledOpenTicket: "Desabilitado",
          selectUser: "Usuário",
          selectQueue: "Fila",
          statusTicket: "Status do Ticket",
          closedTicketStatus: "Fechado",
          openTicketStatus: "Aberto",
          pendingTicketStatus: "Pendente",
          interval: "Intervalo",
          intervalValue: "Valor do Intervalo",
          sendTimes: "Enviar quantas vezes",
          sendType: "Tipo de Envio",
          sendNormally: "Enviar normalmente em dias não úteis",
          sendBeforeWorkday: "Enviar um dia útil antes",
          sendAfterWorkday: "Enviar um dia útil depois",
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        sections: {
          message: "Informações da Mensagem",
          settings: "Configurações de Envio",
          recurrence: "Recorrência",
          recurrenceDescription:
            "Configure em quanto tempo a mensagem será repetida e quantas repetições adicionais deseja. Mantenha o intervalo em 0 para um único envio e utilize as opções de dias úteis para antecipar ou postergar quando cair em fins de semana.",
        },
        helper: {
          interval:
            "Combine esta unidade com o valor ao lado (ex.: 2 + Semanas = a cada duas semanas).",
          intervalValue:
            "Quantidade de unidades entre cada envio. Use 0 para não repetir.",
          sendTimes:
            "Quantidade de repetições adicionais após o envio atual. Ex.: 3 = envio agora + 3 repetições.",
          dayType:
            "Defina como reagendar quando a data calculada cair em fins de semana.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          close: "Fechar",
          addSchedule: "Adicionar agendamento",
          attach: "Anexar Arquivo",
        },
        success: "Agendamento salvo com sucesso.",
        confirmationModal: {
          deleteTitle: "Deletar Anexo?",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        toasts: {
          deleted: "Anexo removido com sucesso.",
        },
        tabs: {
          message: "Mensagem",
          settings: "Configurações",
        },
        userSchedule: {
          details: "Agendamento para Usuário",
          responsible: "Usuário responsável",
          ownResponsibleHint: "Você só pode criar agendamentos para si mesmo.",
          title: "Título",
          description: "Descrição",
          observations: "Observações",
          createdBy: "Criado por",
          createdAt: "Data da criação",
          updatedAt: "Última alteração",
          status: "Status",
          complete: "Concluir",
          completed: "Agendamento concluído com sucesso.",
        },
        dropzoneText:
          "Arraste e solte um arquivo aqui, ou clique para selecionar",
        readOnlyAttachments:
          "Este agendamento já foi enviado. Nenhuma alteração é permitida.",
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Redirecionar em (Horas)",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          rollbackLaneId: "Voltar após retomar atendimento",
          kanbanSettings: "Configurações da Lane",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
        contacts: "Contatos",
        noContactsMessage: "Nenhum contato vinculado a esta tag.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Novo",
        modal: {
          conversation: "Início",
          title: "Título",
          filterUsers: "Filtro por Usuários",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
        noQueue: "Sem fila",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        attachDocument: "Anexar documento (privado)",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          start: "Iniciar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          queues: "Filas & Chatbot",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          settings: "Configurações",
          files: "Gerenciador de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Gerência",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          theme: {
            dark: "Modo Escuro",
            light: "Modo Claro",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      chatIndex: {
        modal: {
          title: "Criar Grupo",
          editTitle: "Editar Grupo",
          cancel: "Cancelar",
          save: "Salvar",
        },
        all: "Todos",
        chats: "Chats",
        groups: "Grupos",
        createGroup: "Criar grupo",
        createDirect: "Novo chat",
        createGroupShort: "Novo grupo",
        directTooltip: "Criar chat direto",
        groupDialogTitle: "Criar grupo de chat interno",
        groupUsersRequired: "Selecione pelo menos 2 atendentes para criar o grupo.",
        groupNameRequired: "Informe o nome do grupo.",
        directCreateSuccess: "Chat criado com sucesso.",
        groupCreateSuccess: "Grupo de chat criado com sucesso.",
        creating: "Criando...",
        cancel: "Cancelar",
        save: "Salvar",
        deleteGroup: "Excluir grupo",
        deleteGroupConfirm: "Tem certeza que deseja excluir este grupo?",
        delete: "Excluir",
      },
      chatList: {
        noMessages: "Sem mensagens",
        now: "Agora",
        minutesAgo: "há {{count}} min",
        hoursAgo: "há {{count}} h",
        edit: "Editar",
        delete: "Excluir",
        details: "Detalhes",
        deleteChat: "Excluir chat",
        deleteChatConfirm: "Tem certeza que deseja excluir este chat?",
        detailsTitle: "Detalhes do chat",
        admin: "Administrador",
        member: "Membro",
        searchChat: "Buscar chat",
        createNewChat: "Novo chat",
        searchUser: "Buscar usuário",
        noUserFound: "Nenhum usuário encontrado",
        noUserAvailable: "Nenhum usuário disponível",
        cancel: "Cancelar",
      },
      chatMessages: {
        edit: "Editar",
        delete: "Excluir",
        forward: "Encaminhar",
        reply: "Responder",
        deleted: "Mensagem excluída",
        deletedAdmin: "Mensagem excluída (visível para administrador)",
        replyingTo: "Respondendo para",
        forwarded: "Encaminhada",
        clickToGoToOriginal: "Clique para ir à mensagem original",
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) e Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldTicketId: '"ticketId": 123 (opcional, continua no ticket)',
        fieldTagId: '"tagId": 10 (opcional, aplica tag no ticket)',
        fieldIsPrivate:
          '"isPrivate": "texto da nota privada interna" (opcional)',
        fieldBody: '"body": "Mensagem"',
        fieldUserId: '"userId"/"ticketUserId": ID do usuário ou ""',
        fieldQueueId: '"queueId"/"ticketQueueId": ID da Fila ou ""',
        fieldSendSignature: '"sendSignature": Assinar mensagem - true/false',
        fieldCloseTicket: '"closeTicket": Encerrar o ticket - true/false',
        curlExampleNormalTitle: "Exemplo cURL (envio normal):",
        curlExamplePrivateTitle:
          "Exemplo cURL (nota privada + troca de fila/atendente):",
        curlExampleGetTitle: "Exemplo cURL (GET - histórico do ticket em texto):",
        curlExampleGetInfoTitle:
          "Exemplo cURL (GET - filas e usuários online da conexão):",
        curlExampleNormal:
          "curl --location 'https://whatsapi.360house.com.br/api/messages/send' \\\n--header 'Authorization: Bearer SEU_TOKEN' \\\n--header 'Content-Type: application/json' \\\n--data '{\n  \"number\": \"554899954641\",\n  \"body\": \"Bom dia\"\n}'",
        curlExamplePrivate:
          "curl --location 'https://whatsapi.360house.com.br/api/messages/send' \\\n--header 'Authorization: Bearer SEU_TOKEN' \\\n--header 'Content-Type: application/json' \\\n--data '{\n  \"ticketId\": 65,\n  \"ticketQueueId\": 3,\n  \"ticketUserId\": 11,\n  \"isPrivate\": \"mensagem privada para o atendente\"\n}'",
        curlExampleGet:
          "curl --location --request GET 'https://whatsapi.360house.com.br/api/messages/send?ticketId=65' \\\n--header 'Authorization: Bearer SEU_TOKEN' \\\n--header 'Content-Type: application/json'",
        curlExampleGetInfo:
          "curl --location 'http://localhost:8080/api/messages/send/info' \\\n--header 'Authorization: Bearer SEU_TOKEN' \\\n--header 'Content-Type: application/json'",
        singMessage: "Assinar mensagem - true/false",
        closeTicket: "Encerrar o ticket - true/false",
        testSend: "Teste de envio",
      },
      notifications: {
        title: "Notificações",
        noTickets: "Nenhuma notificação.",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        dropzoneText:
          "Arraste e solte um arquivo aqui, ou clique para selecionar",
        viewAttachment: "Ver Anexo",
        noAttachment: "Sem anexo",
        preview: {
          title: "Visualização do Anexo",
          close: "Fechar",
        },
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          info: "Mensagens Rápidas",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
          attachment: "Anexo",
          visibility: "Visibilidade",
          visibilityUserSpecific: "Exclusiva para um usuário",
          visibilityAdminPrivate: "Só para mim (Admin)",
          visibilityGlobal: "Para todos",
          assignedUser: "Usuário Atribuído",
          none: "Nenhum",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          progress: "Progresso",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
            basic: "Informações Básicas",
            selection: "Seleção de Contatos",
            ticket: "Configurações de Ticket",
            messages: "Mensagens",
            config: "Configurações",
            confirmationTimeoutHours: "Timeout de confirmação (minutos)",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
          needWhatsapp:
            "É necessário selecionar uma conexão de WhatsApp para a campanha",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        notRegister: "Nenhum anúncio",
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
      },
      queues: {
        title: "Filas & Chatbot",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila excluída com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        table: {
          id: "Ticket",
          phone: "Telefone",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Filtrar",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimento abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          list: "Lista",
          new: "Nova empresa",
          edit: "Editar empresa",
          cancel: "Cancelar",
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          diskUsage: "Uso de Disco",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
        },
      },
      helps: {
        title: "Central de Ajuda",
        new: "Nova Ajuda",
        edit: "Editar Ajuda",
        table: {
          ID: "ID",
          title: "Título",
          description: "Descrição",
          video: "Vídeo",
          actions: "Ações",
        },
        settings: {
          title: "Título",
          codeVideo: "Código do Vídeo",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
        buttons: {
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
      schedules: {
        title: "Agendamentos",
        filters: {
          type: "Tipo",
          allTypes: "Todos os tipos",
          send: "Agendamento de envio",
          internal: "Agendamento interno",
          user: "Agendamento para Usuário",
          userLabel: "Usuário",
          allUsers: "Todos os usuários",
          myAgenda: "Minha agenda",
        },
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            operationUpdated: "Operação atualizada com sucesso.",
            asaasTab: "ASAAS",
            asaasTokenLabel: "Token Asaas",
            asaasTokenSaved: "Token salvo.",
            asaasTokenNotConfigured: "Token não configurado.",
            asaasTokenSaveError: "Não foi possível salvar o token do Asaas.",
            asaasEnvLabel: "Ambiente Asaas",
            asaasEnvProduction: "Produção (https://api.asaas.com/)",
            asaasEnvSandbox: "Sandbox (https://api-sandbox.asaas.com/)",
            asaasEnvSaved: "Ambiente salvo: {{env}}.",
            asaasEnvNotConfigured: "Ambiente não configurado.",
            asaasEnvSaveError: "Não foi possível salvar o ambiente do Asaas.",
            transferredTicketStatus: "Status ao transferir c/ usuário",
            statusOpen: "Aberto",
            statusPending: "Pendente",
            statusClosed: "Fechado",
            randomizeOnManualTransfer: "Randomizar em transf. manual",
            copyContactSettingsTab: "Configuração de Sigla para Cópia de Contato",
            copyContactPrefix: "Sigla para cópia de contato",
            copyContactPrefixPlaceholder: "Ex: CL_",
            removeCountryCodeOnCopy: "Remover código do país ao copiar",
            removeAreaCodeOnCopy: "Remover DDD ao copiar",
            remove9thDigitOnCopy: "Remover 9º dígito ao copiar",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de transferência - '{queue.name}' = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Selecione pelo menos uma mensagem para encaminhar.",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            menu: "Mais opções",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
          },
        },
        body: {
          greeting: "Diga olá para seu novo contato!",
          today: "Hoje",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen: "Digite algo ou / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        editing: "Editando",
        editingPlaceholder: "Edite a mensagem...",
        saveEdit: "Salvar edição",
        sendTemplate: "Enviar template",
        template: {
          select: "Selecionar template HSM",
        },
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          schedule: "Agendar mensagem",
        },
        buttons: {
          media: "Fotos e vídeos",
          camera: "Câmera",
          contact: "Contato",
          meet: "Reunião",
          document: "Documentos",
        },
      },
      messageOptionsMenu: {
        title: "Opções",
        delete: "Apagar",
        edit: "Editar",
        reply: "Responder",
        forward: "Encaminhar",
        talkTo: "Conversar",
        downloadAudio: "Baixar Áudio",
        confirmationModal: {
          title: "Apagar mensagem",
          message: "Esta ação não pode ser revertida. Deseja continuar?",
        },
      },
      agendaCare: {
        title: "AgendaCare",
        tabs: {
          calendar: "Agenda",
          doctors: "Médicos",
          patients: "Pacientes",
          specialties: "Especialidades",
          messaging: "Mensagens"
        },
        buttons: {
          addDoctor: "Adicionar Médico",
          addPatient: "Adicionar Paciente",
          loadMore: "Carregar Mais",
          refresh: "Atualizar"
        },
        table: {
          id: "ID",
          name: "Nome",
          specialty: "Especialidade",
          cpf: "CPF",
          phone: "Telefone"
        },
        filters: {
          doctor: "Filtrar por Médico",
          specialty: "Filtrar por Especialidade",
          room: "Filtrar por Sala",
          all: "Todos"
        },
        calendar: {
          next: "Próximo",
          previous: "Anterior",
          today: "Hoje",
          month: "Mês",
          week: "Semana",
          day: "Dia",
          agenda: "Agenda",
          date: "Data",
          time: "Hora",
          event: "Evento",
          noEventsInRange: "Nenhum evento no período selecionado"
        }
      },
      doctorModal: {
        title: {
          add: "Adicionar Médico",
          edit: "Editar Médico"
        },
        form: {
          name: "Nome",
          specialty: "Especialidade",
          contact: "Contato WhatsApp (Busque por nome)",
          dailyAgenda: "Receber Agenda Diária"
        },
        buttons: {
          cancel: "Cancelar",
          okAdd: "Adicionar",
          okEdit: "Salvar"
        },
        success: {
          create: "Médico criado com sucesso!",
          update: "Médico atualizado com sucesso!"
        }
      },
      patientModal: {
        title: {
          add: "Novo Paciente",
          edit: "Editar Paciente"
        },
        form: {
          name: "Nome *",
          cpf: "CPF",
          birthDate: "Data de Nascimento",
          contact: "Contato",
          none: "Nenhum"
        },
        buttons: {
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando..."
        },
        success: {
          create: "Paciente criado com sucesso!",
          update: "Paciente atualizado com sucesso!"
        },
        validation: {
          nameRequired: "Nome é obrigatório"
        }
      },
      specialtyModal: {
        title: {
          add: "Nova Especialidade",
          edit: "Editar Especialidade"
        },
        form: {
          name: "Nome da Especialidade",
          category: "Categoria",
          active: "Ativa"
        },
        categories: {
          medicine: "Medicina",
          dentistry: "Odontologia",
          nursing: "Enfermagem"
        },
        buttons: {
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando..."
        },
        success: {
          create: "Especialidade criada com sucesso!",
          update: "Especialidade atualizada com sucesso!"
        },
        validation: {
          nameRequired: "Nome é obrigatório",
          categoryRequired: "Categoria é obrigatória"
        }
      },
      specialties: {
        title: "Especialidades Médicas",
        searchPlaceholder: "Buscar especialidade...",
        categoryFilter: "Filtrar por Categoria",
        allCategories: "Todas as Categorias",
        buttons: {
          add: "Nova Especialidade"
        },
        table: {
          id: "ID",
          name: "Nome",
          category: "Categoria",
          status: "Status",
          actions: "Ações"
        },
        status: {
          active: "Ativa",
          inactive: "Inativa"
        },
        confirmationModal: {
          deleteTitle: "Excluir Especialidade",
          deleteMessage: "Tem certeza que deseja excluir esta especialidade?"
        },
        toasts: {
          deleted: "Especialidade excluída com sucesso!"
        }
      },
      appointmentModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento"
        },
        form: {
          patient: "Paciente",
          doctor: "Médico",
          date: "Data",
          time: "Hora",
          notes: "Observações"
        },
        buttons: {
          save: "Salvando...",
          schedule: "Agendar",
          cancelAppointment: "Cancelar Agendamento"
        },
        success: {
          create: "Agendamento criado com sucesso!",
          update: "Agendamento atualizado com sucesso!",
          cancel: "Agendamento cancelado com sucesso!"
        }
      },
      messageTemplates: {
        title: {
          main: "Templates de Mensagens",
          add: "Novo Template",
          edit: "Editar Template"
        },
        searchPlaceholder: "Buscar template...",
        typeFilter: "Filtrar por Tipo",
        allTypes: "Todos os Tipos",
        buttons: {
          add: "Novo Template",
          cancel: "Cancelar",
          save: "Salvar",
          saving: "Salvando..."
        },
        form: {
          name: "Nome do Template",
          type: "Tipo de Mensagem",
          recipient: "Destinatário",
          subject: "Assunto",
          message: "Mensagem",
          availableVariables: "Variáveis Disponíveis (clique para inserir)",
          requiresConfirmation: "Requer Confirmação do Paciente",
          option1: "Opção 1",
          option2: "Opção 2",
          option3: "Opção 3 (Opcional)",
          autoSend: "Envio Automático",
          sendBeforeHours: "Enviar X horas antes",
          active: "Ativo"
        },
        types: {
          confirmation: "Confirmação de Consulta",
          reminder: "Lembrete",
          cancellation: "Cancelamento",
          rescheduling: "Reagendamento",
          dailyAgenda: "Agenda Diária",
          confirmationReceived: "Confirmação Recebida",
          cancellationReceived: "Cancelamento Recebido"
        },
        recipients: {
          patient: "Paciente",
          doctor: "Médico",
          both: "Ambos"
        },
        table: {
          name: "Nome",
          type: "Tipo",
          recipient: "Destinatário",
          autoSend: "Envio Automático",
          status: "Status",
          actions: "Ações",
          before: "antes"
        },
        status: {
          active: "Ativo",
          inactive: "Inativo"
        },
        confirmationModal: {
          deleteTitle: "Excluir Template",
          deleteMessage: "Tem certeza que deseja excluir este template de mensagem?"
        },
        success: {
          create: "Template criado com sucesso!",
          update: "Template atualizado com sucesso!"
        },
        validation: {
          nameRequired: "Nome é obrigatório",
          typeRequired: "Tipo é obrigatório",
          messageRequired: "Mensagem é obrigatória"
        },
        toasts: {
          deleted: "Template excluído com sucesso!"
        }
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_PAUSED:
          "Sessão do WhatsApp está pausada. Retome a conexão para enviar mensagens.",
        ERR_CLOUD_API_TOKEN_INVALID:
          "Token da API Oficial inválido ou expirado. Atualize o token da conexão.",
        ERR_CLOUD_API_MISSING_CONFIG:
          "A conexão Cloud API está incompleta. Atualize os dados da conexão.",
        ERR_SENDING_CLOUD_API_TEMPLATE:
          "Falha ao enviar template da API Oficial. Verifique o template selecionado.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_QUEUE_PROMPTS_EXIST:
          "Não é possível excluir esta fila pois existem Prompts de IA associados a ela. Remova ou altere os Prompts primeiro.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_TRANSFER_WHATSAPP_REQUIRED:
          "Selecione uma conexão de destino para transferir os tickets antes de prosseguir.",
        ERR_TRANSFER_WHATSAPP_INVALID_TARGET:
          "A conexão selecionada para transferência é inválida.",
        ERR_TRANSFER_WHATSAPP_TARGET_IN_REMOVAL:
          "A conexão escolhida para transferência também está sendo removida. Escolha outra.",
        ERR_TRANSFER_WHATSAPP_TARGET_NOT_FOUND:
          "Conexão de destino não encontrada para esta empresa.",
        ERR_TRANSFER_WHATSAPP_CHANNEL_MISMATCH:
          "A conexão de destino deve ser do mesmo canal ou compatível entre WhatsApp e Evolution.",
        ERR_TRANSFER_WHATSAPP_SAME_TARGET:
          "Selecione uma conexão diferente para transferência.",
      },
      erpPhone: {
        signature: {
          title: "Assinatura Digital ERP-PHONE",
          document: "Documento",
          content: "Conteúdo",
          alreadySigned: "Documento já assinado em {{date}}.",
          expired: "Este link de assinatura expirou.",
          invalidToken: "Link de assinatura inválido.",
          signHere: "Assine no campo abaixo:",
          selfie: "Capturar/Enviar Selfie",
          clear: "Limpar",
          sign: "Assinar Documento",
          saving: "Salvando...",
          signatureRequired: "Assinatura é obrigatória.",
          loadError: "Não foi possível carregar o documento.",
          signError: "Falha ao assinar documento.",
          loading: "Carregando...",
        },
      },
    },
  },
};

export { messages };
